const palette = {
  mode: 'light',
  background: {
    paper: '#1B1517',
    default: '#1B1517',
  },
  common: {
    black: '#000',
    white: '#fff',
  },
  primary: {
    main: '#BA0A5F',
    dark: '#BA0A5F',
    contrastText: '#fff',
  },
  secondary: {
    main: '#1F2128',
    dark: '#191b21',
    contrastText: '#fff',
  },
  info: {
    main: '#414DA4',
  },
  success: {
    main: '#BA0A5F',
    dark: '#FF057D',
    contrastText: '#FFFBFF',
  },
  warning: {
    light: '#FFE58F',
    main: '#FAAD14',
  },
  error: {
    main: '#8D0D4A',
    dark: '#bc4538',
    contrastText: '#fff',
  },
  bankIdViolet: {
    main: '#39134C',
    dark: '#2a0140',
    contrastText: '#fff',
  },
  orange: {
    main: '#F7931A',
    contrastText: '#fff',
  },

  text: {
    primary: '#ffffff',
    secondary: '#757785',
  },

  textInverted: '#FFFFFF',
  textBlueish: '#324A57',

  greyDefault: '#9FA2B4',

  border: 'rgba(161, 197, 239, 0.24);',
  borderLight: '#D9D9D9',
  placeholder: '#C4C4C4',
  bgLight: '#190900',

  grey: {
    900: '#262626', // grey 9, texts
    800: '#595959', // grey 8, texts
    700: '#9FA2B4', // gray 7, placeholders
    600: '#BFBFBF', // grey 6, light texts
    300: '#DFE0EB', // border gray
    200: '#EAEFF4', // border color
    100: '#F7F8FC', // BG
  },
}

export default palette
